import { Global, css } from "@emotion/react";
import { useTheme } from "../context/ThemeContext";
import { lightTheme, darkTheme } from "./theme";

export const GlobalStyles = () => {
  const { theme } = useTheme();
  const currentTheme = theme === "light" ? lightTheme : darkTheme;

  const globalStyles = css`
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      transition:
        background-color 0.2s ease,
        color 0.2s ease,
        border-color 0.2s ease,
        box-shadow 0.2s ease;
    }

    body {
      font-family:
        "Space Grotesk",
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        "Roboto",
        sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      background-color: ${currentTheme.background};
      color: ${currentTheme.text};
      line-height: 1.5;
      font-weight: 500;
      overflow-x: hidden;
      width: 100%;
    }

    html {
      scroll-behavior: smooth;
      overflow-x: hidden;
      width: 100%;
    }

    a {
      text-decoration: none;
      color: inherit;
      font-weight: 700;
    }

    button {
      border: none;
      outline: none;
      cursor: pointer;
      background: none;
      font-family: "Space Grotesk", sans-serif;
      font-weight: 700;
    }

    ::selection {
      background-color: ${currentTheme.accent};
      color: ${currentTheme.background};
      text-shadow: none;
    }

    ::-moz-selection {
      background-color: ${currentTheme.accent};
      color: ${currentTheme.background};
      text-shadow: none;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: 900;
      letter-spacing: -0.02em;
      line-height: 1.1;
    }

    h1 {
      font-size: clamp(2.5rem, 5vw, 4.5rem);
    }

    h2 {
      font-size: clamp(2rem, 4vw, 3.5rem);
    }

    h3 {
      font-size: clamp(1.5rem, 3vw, 2.5rem);
    }

    strong {
      font-weight: 900;
    }

    code,
    pre {
      font-family: "Space Mono", "Courier New", monospace;
      font-weight: 400;
    }

    /* Hide scrollbar for desktop */
    @media (min-width: 768px) {
      ::-webkit-scrollbar {
        display: none;
      }

      body {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
    }

    /* Add subtle animation to page */
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    body {
      animation: fadeIn 0.3s ease-in;
    }

    /* Ensure smooth font rendering */
    * {
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    /* Focus visible for accessibility */
    *:focus-visible {
      outline: 4px solid ${currentTheme.accent};
      outline-offset: 4px;
    }
  `;

  return <Global styles={globalStyles} />;
};
